// client/constants/systemCommsApi.js
import api from "./api.js";

const S = "/system";

export const ReleasesAPI = {
  latest:    ()         => api.get(`${S}/releases/latest`, { silent: true }).then(r => r.data),
  markSeen:  (version)  => api.post(`${S}/releases/mark-seen`, { version }).then(r => r.data),
  detail:    (version)  => api.get(`${S}/releases/${encodeURIComponent(version)}`).then(r => r.data),

  adminList: (opts = {}) => api.get(`${S}/admin/releases`, { params: { includeUnpublished: opts.includeUnpublished ? "1" : undefined } }).then(r => r.data),
  adminCreate: (body)    => api.post(`${S}/admin/releases`, body).then(r => r.data),
  adminUpdate: (id, body) => api.put(`${S}/admin/releases/${id}`, body).then(r => r.data),
  adminPublish: (id)     => api.post(`${S}/admin/releases/${id}/publish`).then(r => r.data),
  adminUnpublish: (id)   => api.post(`${S}/admin/releases/${id}/unpublish`).then(r => r.data),
  adminDelete: (id)      => api.delete(`${S}/admin/releases/${id}`).then(r => r.data),
};

export const HelpAPI = {
  list:       (params = {}) => api.get(`${S}/help`, { params }).then(r => r.data),
  bySlug:     (slug)        => api.get(`${S}/help/${encodeURIComponent(slug)}`).then(r => r.data),

  adminList:  (opts = {}) => api.get(`${S}/admin/help`, { params: { includeUnpublished: opts.includeUnpublished ? "1" : undefined } }).then(r => r.data),
  adminCreate: (body)     => api.post(`${S}/admin/help`, body).then(r => r.data),
  adminUpdate: (id, body) => api.put(`${S}/admin/help/${id}`, body).then(r => r.data),
  adminPublish: (id)      => api.post(`${S}/admin/help/${id}/publish`).then(r => r.data),
  adminUnpublish: (id)    => api.post(`${S}/admin/help/${id}/unpublish`).then(r => r.data),
};

export const OnboardingAPI = {
  status:     ()          => api.get(`${S}/onboarding/status`, { silent: true }).then(r => r.data),
  complete:   ()          => api.post(`${S}/onboarding/complete`).then(r => r.data),
  adminReset: (user_id)   => api.post(`${S}/admin/onboarding/reset`, { user_id }).then(r => r.data),
  adminSearchUsers: (q)   => api.get(`${S}/admin/users/search`, { params: { q } }).then(r => r.data),
};

export const WartungConfigAPI = {
  adminGet: () => api.get(`${S}/admin/wartung-config`).then((r) => r.data),
  saveAgb: (typ, body) => api.put(`${S}/admin/wartung-config/agb/${encodeURIComponent(typ)}`, body).then((r) => r.data),
  savePakete: (typ, pakete) => api.put(`${S}/admin/wartung-config/pakete/${encodeURIComponent(typ)}`, { pakete }).then((r) => r.data),
};
